// * --------------- GENERAL

export const isBrowserHelper = () => typeof window !== "undefined";

// * --------------- STRINGS

export const capitalize = (word: string) => {
  return `${word[0].toLocaleUpperCase()}${word.slice(1)}`;
};
